import styled from 'styled-components';
import { FlexCenterAligned } from '../../../../../styled/common';

export const PricePlaceholder = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
`;

export const ManatIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  vertical-align: middle;
`;

export const CheckBoxesContainer = styled(FlexCenterAligned)`
  gap: 10px;
`;

export const CheckBoxWrapper = styled.div`
  flex: 1;
  background-color: ${({ theme }) => theme.colors.background.tertiary};
  border: 1px solid ${({ theme }) => theme.colors.border.secondary};
  border-radius: 14px;
  padding: 4px 15px;
`;
